import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Input, Badge } from 'reactstrap';

import { callApi } from '../../utils';
import { showError } from '../../actions/notificationActions';

import SearchForm from '.././SearchForm';
import DataTable, { PageHeader } from '../DataTable';

// The list covers every vendable service (34 electricity discos, 4 telcos,
// 3 TV), so it is grouped by category and filterable rather than a flat table.
const VERTICALS = [
  { value: '', label: 'All verticals' },
  { value: 'ELECTRICITY', label: 'Electricity' },
  { value: 'TELCO', label: 'Airtime & Data' },
  { value: 'TV', label: 'Cable TV' },
];

// Groups rows by their display category, keeping the order the API returned.
const groupByCategory = (rows) => {
  const groups = [];
  const index = {};

  rows.forEach((row) => {
    const key = row.category || 'Other';
    if (index[key] === undefined) {
      index[key] = groups.length;
      groups.push({ category: key, rows: [] });
    }
    groups[index[key]].rows.push(row);
  });

  return groups;
};

class List extends Component {
  state = {
    rows: [],
    query: '',
    vertical: '',
    page: 1,
    limit: 50,
    loading: false,
    pages: 1,
    total: 0,
  };

  componentWillMount() {
    this.load();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  load = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, vertical, page, limit } = this.state;

    this.startLoad();

    const params = { q: query, page, limit };
    // Only send the filter when one is picked — an empty value is not a vertical.
    if (vertical) params.vertical = vertical;

    callApi('/services', params)
      .then(({ data = [], meta = {} }) => {
        this.setState({
          loading: false,
          rows: data,
          pages: meta.pages || 1,
          total: meta.total || data.length,
        });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, this.load);
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  setVertical = (e) => {
    // Filtering is server-side, so restart from the first page.
    this.setState({ vertical: e.target.value, page: 1 }, this.load);
  };

  view = (id) => {
    this.props.history.push(`/services/${id}`);
  };

  renderRows() {
    const { rows, loading } = this.state;

    if (!rows.length) {
      return (
        <tbody>
          <tr>
            <td colSpan={4} className="text-center text-muted py-4">
              {loading ? '' : 'No services match this search.'}
            </td>
          </tr>
        </tbody>
      );
    }

    return groupByCategory(rows).map((group) => (
      <tbody key={group.category}>
        <tr>
          <td
            colSpan={4}
            className="text-primary"
            style={{
              fontWeight: 600,
              textTransform: 'uppercase',
              fontSize: '11px',
              letterSpacing: '0.5px',
              background: '#f7f7f7',
            }}
          >
            {group.category} ({group.rows.length})
          </td>
        </tr>
        {group.rows.map((t) => (
          <tr
            onClick={() => this.view(t.id)}
            key={t.id}
            style={{ cursor: 'pointer' }}
          >
            <td>{t.code}</td>
            <td>{t.name}</td>
            <td>{t.category}</td>
            <td>
              <Badge color={t.active ? 'success' : 'danger'}>
                {t.active ? 'ACTIVE' : 'OFF'}
              </Badge>
            </td>
          </tr>
        ))}
      </tbody>
    ));
  }

  render() {
    const { query, vertical, page, loading, pages, total } = this.state;

    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="Services"
              subtitle={
                <>
                  {total} service{total === 1 ? '' : 's'} · Page {page}
                </>
              }
            >
              <Input
                type="select"
                value={vertical}
                onChange={this.setVertical}
                disabled={loading}
                style={{ maxWidth: 220 }}
              >
                {VERTICALS.map((v) => (
                  <option key={v.value} value={v.value}>
                    {v.label}
                  </option>
                ))}
              </Input>
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.load}
                loading={loading}
                placeholder="Search by name or code..."
              />
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              total={pages}
              page={page}
              onPageChange={this.setPage}
            >
              <thead className="text-primary">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Status</th>
                </tr>
              </thead>
              {this.renderRows()}
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(List);
